import React, { Component } from 'react';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import ClientTabs from './topmenu';
import ListClients from './listclients';
import ClientUsers from './clientusers'
import * as Constants from '../../common/Global/constants';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import { isEmptyVariable,getThemeSettingsVariables, getLocalStorageVariables, isJsonString, handleTokenExpiry } from '../../common/Global/commonFunctions';
import { setClientSubscription } from '../../../reducers/authSlice';
import { connect } from "react-redux";

let themeSettings = getThemeSettingsVariables();
let userDetails = {};

class ClientsMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientId:"",
            clientName:"",
            displayingClients:true,
            displayingClientUsers:false,
            displayCards:true,
            displayingTemplates:false,
            departmentList:[]
        }
    }
    
    componentDidMount(){
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    viewClientUsersDropDownItemClick = (clientId,clientName) => {
        this.setState({
            clientId:clientId,
            clientName:clientName,
            displayingClients:false,
            displayingClientUsers:true,
        })
    }

    showTemplatesDropDownItemClick = (clientId,clientName,departmentList) => {
        this.getInitData(clientId, clientName, departmentList);
    }

    showDashboard = (clientId,companyName,departmentList) => {
        this.props.history.push(Constants.URL_CLIENTDASHBOARD+"/"+clientId,{
            companyName:companyName,
            departmentList:departmentList
        })
    }

    usersTabItemOnClick = (clientId) => {
        this.setState({
            clientId:clientId,
            displayingClients:false,
            displayingClientUsers:true,
        })
    }

    clientsTabItemOnClick = () =>{
        this.setState({
            displayingClients:true,
            displayingClientUsers:false,
        })
    }  
    
    toggleCardsDisplay = () =>{
        this.setState({
            displayCards:!this.state.displayCards
        })
    }

    getInitData = (clientId,clientName,departmentList) => {
        fetch(Constants.Subsciptions+clientId,
        {
            method: "POST",
            mode: 'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                const clientSubscriptions = isJsonString(data.subscriptionList) ? JSON.parse(data.subscriptionList) : data.subscriptionList;
                this.props.setClientSubscription(clientSubscriptions);
                this.props.history.push(Constants.URL_TASK_TEMPLATES,{
                    clientId:clientId,
                    clientName:clientName,
                    displayingClients:false,
                    departmentList:departmentList
                })
            }else{
                this.setState({
                    showAlertDialogInfo:true,
                    alertDialogMessageInfo:data.responseMessage,
                })
            }
        });
    }

    render() {
        themeSettings  = getThemeSettingsVariables();
        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />

                                <ClientTabs 
                                    clientId = {this.state.clientId}
                                    displayingClients = {this.state.displayingClients}
                                    displayingClientUsers = {this.state.displayingClientUsers}
                                    displayingTemplates={this.state.displayingTemplates}
                                    departmentList={this.state.departmentList}
                                    usersTabItemOnClick = {this.usersTabItemOnClick}
                                    clientsTabItemOnClick = {this.clientsTabItemOnClick}
                                    toggleCardsDisplay = {this.toggleCardsDisplay}
                                    themeSettings = {themeSettings}
                                    showInfo={true}
                                />

                                {
                                    this.state.displayingClients &&
                                    <ListClients 
                                        viewClientUsersDropDownItemClick = {this.viewClientUsersDropDownItemClick}
                                        showTemplatesDropDownItemClick={this.showTemplatesDropDownItemClick}
                                        showDashboard={this.showDashboard}
                                        displayCards={this.state.displayCards}
                                        themeSettings = {themeSettings}
                                    />
                                }

                                {
                                    !isEmptyVariable(this.state.clientId) &&
                                    this.state.displayingClientUsers &&
                                    <ClientUsers 
                                        clientId = {this.state.clientId}
                                        clientName = {this.state.clientName}
                                        displayCards={this.state.displayCards}
                                        themeSettings = {themeSettings}
                                    />
                                }
                            </div>
                        </div>
                    </section>
                </main>
            </Router>
        )
    }
}

export default connect(null, { setClientSubscription })(ClientsMain);

